export const MAIN_SECTION_ID = 'gift_certificate_content';
